import React from 'react';
import { Card } from 'antd';

const MetaData = ({ process, finalParams, config }) => {
  return (
    <Card title="Process Metadata">
      <p><strong>Process:</strong> {process}</p>
      <p><strong>Final Parameters:</strong></p>
      <ul>
        {Object.entries(finalParams).map(([key, value]) => (
          <li key={key}>{`${key}: ${value}`}</li>
        ))}
      </ul>
      <p><strong>Simulation Config:</strong></p>
      <ul>
        {Object.entries(config).map(([key, value]) => (
          <li key={key}>{`${key}: ${value}`}</li>
        ))}
      </ul>
    </Card>
  );
};

export default MetaData;
